import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { AssetSettingsEntities } from "./config";
import { isEnabled } from "../../services/featureFlags";

export const getListForCommonFilter = (params, entity, source = "") =>
    entity === "manufacturer"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}/get_list`, { params })
        : entity === "client_standards"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/`, { params })
        : entity === "client_standards_hierarchy"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.getassetSettingsClientStandardHierarchy}`, { params })
        : entity === "entity"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsEntity}`, { params })
        : source === "global" && entity === "condition"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.globalProjectSettingsAssetCondition}`, { params })
        : entity === "condition"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/get_list`, { params })
        : fcaGateWay.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/get_list`, {
              params
          });

export const getDataList = (params, entity, source = "") =>
    entity === "manufacturer"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}`, { params })
        : entity === "client_standards"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/`, {
              params,
              ...(params.report ? { responseType: "blob" } : {})
          })
        : entity === "asset_dynamic_dictionary"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/`, { params })
        : entity === "client_standards_hierarchy"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.getassetSettingsClientStandardHierarchy}`, {
              params,
              ...(params.report ? { responseType: "blob" } : {})
          })
        : entity === "entity"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsEntity}`, {
              params,
              ...(params.report ? { responseType: "blob" } : {})
          })
        : source === "global" && entity === "condition"
          ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.globalProjectSettingsAssetCondition}`, { params })
          : entity === "condition"
            ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}`, { params })
            : fcaGateWay.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}`, { params });

export const addData = (params, entity, source = null) =>
    entity === "manufacturer"
        ? isEnabled("migrate_report_config")
            ? fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturerFastApi}`, params)
            : fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}`, params)
        : entity === "recommendation_assets_costing_templates"
        ? fcaReportGateway.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsRecommendationAssetTemplate}/`, params)
        : entity === "asset_scope_worksheets"
        ? fcaReportGateway.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsAssetScope}/`, params)
        : entity === "client_standards"
        ? fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}`, {
              ...params,
              dynamic_fields: {}
          })
        : entity === "asset_dynamic_dictionary"
        ? fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}`, params)
        : entity === "client_standards_hierarchy"
        ? fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsClientStandardHierarchy}`, params)
        : entity === "entity"
        ? fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsEntity}create`, params)
        : source === "global" && entity === "condition"
        ? fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.globalProjectSettingsAssetCondition}`, params)
        : entity === "condition"
        ? fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}`, params)
        : fcaGateWay.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}`, {
            [AssetSettingsEntities[entity].apiBodyParam]: params
        });
export const getDataById = (id, entity, source = null) =>
    entity === "manufacturer"
        ? isEnabled("migrate_report_config")
            ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturerFastApi}/${id}`)
            : fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}/${id}`)
        : entity === "recommendation_assets_costing_templates"
        ? fcaReportGateway.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsRecommendationAssetTemplate}/${id}/`)
        : entity === "asset_scope_worksheets"
        ? fcaReportGateway.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsAssetScope}/${id}/`)
        : entity === "client_standards"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`)
        : entity === "client_standards_hierarchy"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.getassetSettingsClientStandardHierarchyById}/${id}`)
        : entity === "entity"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsEntity}${id}`)
        : source === "global" && entity === "condition"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.globalProjectSettingsAssetCondition}/${id}`)
        : entity === "condition"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`)
        : fcaGateWay.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`);

export const updateData = (id, params, entity, source = null) =>
    entity === "manufacturer"
        ? fcaFastApi.patch(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}/${id}`, {
              [AssetSettingsEntities[entity].apiBodyParam]: params
          })
        : entity === "client_standards"
        ? fcaFastApi.put(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`, {
              ...params,
              dynamic_fields: {}
          })
        : entity === "asset_dynamic_dictionary"
        ? fcaFastApi.put(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`, params)
        : entity === "client_standards_hierarchy"
        ? fcaFastApi.put(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsClientStandardHierarchy}${id}`, params)
        : entity === "entity"
        ? fcaFastApi.put(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsEntity}${id}`, params)
        : entity === "condition" && source === "global"
        ? fcaFastApi.put(`${serviceEndpoints.assetSettingsEndPoints.globalProjectSettingsAssetCondition}/${id}`, params)
        : entity === "condition"
        ? fcaFastApi.put(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`, params)
        : fcaGateWay.patch(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`, {
              [AssetSettingsEntities[entity].apiBodyParam]: params
          });
// export const updateDataPiechart = (id, params, entity) =>
//     fcaGateWay.patch(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`,
//      params
//     );

export const deleteData = (id, entity, source = null) =>
    entity === "manufacturer"
        ? isEnabled("migrate_report_config")
            ? fcaFastApi.delete(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturerFastApi}/${id}`)
            : fcaFastApi.delete(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}/${id}`)
        : entity === "recommendation_assets_costing_templates"
        ? fcaReportGateway.delete(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsRecommendationAssetTemplate}/${id}/`)
        : entity === "asset_scope_worksheets"
        ? fcaReportGateway.delete(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsAssetScope}/${id}/`)
        : entity === "client_standards" || entity === "asset_dynamic_dictionary"
        ? fcaFastApi.delete(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`)
        : entity === "client_standards_hierarchy"
        ? fcaFastApi.delete(`${serviceEndpoints.assetSettingsEndPoints.getassetSettingsClientStandardHierarchyById}/${id}`)
        : entity === "entity"
        ? fcaFastApi.delete(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsEntity}/${id}`)
        : source === "global" && entity === "condition"
        ? fcaFastApi.delete(`${serviceEndpoints.assetSettingsEndPoints.globalProjectSettingsAssetCondition}/${id}`)
        : entity === "condition"
        ? fcaFastApi.delete(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`)
        : fcaGateWay.delete(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}`);

export const exportData = (params, entity) =>
    entity === "manufacturer"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}/export_xl`, {
              method: "GET",
              responseType: "blob",
              params
          })
        : fcaGateWay.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/export_xl`, {
              method: "GET",
              responseType: "blob",
              params
          });

export const getAllDataLogs = (id, params, entity, source = "") => {
    if (source === "global") return fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.globalProjectSettingsAssetCondition}/logs`, { params });
    else if (entity === "manufacturer")
        return fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}/${id}/logs`, { params });
    else if (entity === "condition")
        return fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}/logs`, { params });
    else
        return fcaGateWay.get(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/${AssetSettingsEntities[entity].key}/${id}/logs`, { params });
};

export const restoreDataLog = (id, entity, params, source = "") =>
    source === "global"
        ? fcaFastApi.patch(`${serviceEndpoints.assetSettingsEndPoints.globalProjectSettingsAssetCondition}/logs/restore/${id}`, params)
        : entity === "condition" || entity === "manufacturer"
        ? fcaFastApi.patch(`${serviceEndpoints.assetSettingsEndPoints.logs}/${id}/restore`, params)
        : fcaGateWay.patch(`${serviceEndpoints.assetSettingsEndPoints.logs}/${id}/restore`);

export const deleteDataLog = (id, entity, source = "") =>
    source === "global"
        ? fcaFastApi.delete(`${serviceEndpoints.assetSettingsEndPoints.globalProjectSettingsAssetCondition}/logs/${id}`)
        : entity === "condition" || entity === "manufacturer"
        ? fcaFastApi.delete(`${serviceEndpoints.assetSettingsEndPoints.logs}/${id}`)
        : fcaGateWay.delete(`${serviceEndpoints.assetSettingsEndPoints.logs}/${id}`);

export const getDropdownList = (level, params) =>
    level === "uniformat_level_6s"
        ? fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.dropdown[level]}`, { params })
        : fcaGateWay.get(`${serviceEndpoints.assetSettingsEndPoints.dropdown[level]}`, { params });

export const syncData = entity =>
    entity === "asset_scope_worksheets"
        ? fcaReportGateway.put(`${serviceEndpoints.assetSettingsEndPoints.syncAssetScope}`)
        : fcaReportGateway.post(`${serviceEndpoints.assetSettingsEndPoints.syncUniformat6}`);

export const getClientStandardStaticDropdown = params =>
    fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.getClientStandardStaticDropdown}`, { params });
export const getClientStandardVisibleDropdown = id =>
    fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.getClientStandardVisibleDropdown}${id}`);

export const getManufacturerClients = params => fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.getManufacturerClients}`, { params });

export const getManufacturerClientDropdown = params =>
    fcaFastApi.get(`${serviceEndpoints.assetSettingsEndPoints.getManufacturerClientDropdown}`, { params });
